import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 flex">
        <Sidebar />
        <main className="flex-1 ml-64 py-20">
          <div className="p-6">{children}</div>
        </main>
      </div>
    </>
  );
};

export default Layout;
